import React, { JSX, useRef } from 'react';

import { View, ViewStyle } from 'react-native';

import gStyles from 'config/styles';
import { PAGE_TITLE_ID } from 'config/testID';

import { underlayingPlayerModalElementsDataSet } from 'screens/PlayerModal/hooks/useModalAccessibility.ts';

import useAccessibilityFocus from 'components/Gallery/hooks/useAccessibilityFocus';
import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

type Props = {
    title: string;
    style?: ViewStyle;
    renderActionButton?: (() => JSX.Element) | null;
    disableFocusOnMount?: boolean;
};

function WebHeader({
    title,
    style,
    renderActionButton = null,
    disableFocusOnMount = false,
}: Props) {
    const titleRef = useRef<View | null>(null);

    useAccessibilityFocus({
        accessibleViewRef: titleRef,
        focused: !disableFocusOnMount,
    });

    return (
        <View
            style={[styles.root, gStyles.flexRow, style]}
            dataSet={underlayingPlayerModalElementsDataSet}
        >
            <Text
                testID={PAGE_TITLE_ID}
                category={ETextCategory.title3}
                color={ETextColor.neutral}
                style={styles.title}
                // @ts-ignore
                ref={titleRef}
                // @ts-ignore
                tabIndex={-1}
                accessibilityLabel={title}
            >
                {title}
            </Text>

            {renderActionButton && (
                <View style={styles.button}>{renderActionButton()}</View>
            )}
        </View>
    );
}

export default WebHeader;
